import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Virtual tour banner',
    },
  },
};


export function VirtualTourHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="virtualtourhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Virtual tour banner"
    >
      <InnerPageHeroSubtitle path="virtualtourhero.subtitle" />
      <RichTextContent
        path="virtualtourhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="virtualtourhero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="virtualtourhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'VirtualTourHero',
  displayName: 'Virtual Tour Hero',
  tokens: {
    'virtualtourhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Virtual Tour</p>',
    },
    'virtualtourhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Tour Apartments in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'virtualtourhero.bg_image': bgImageDef,
  },
};

(VirtualTourHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default VirtualTourHero;
